import type { ComparisonConfig } from './ComparisonPage';
import { COMPARISON_ZH_P3B } from './seo-comparison-p3b.zh';


const SITEMINDER_ZH: ComparisonConfig = {
  slug: 'hotelstack-vs-siteminder',
  competitorName: 'SiteMinder',
  heroTitle: 'HotelStack.io 对比 SiteMinder',
  heroSubtitle: 'SiteMinder是2006年成立的澳大利亚渠道管理器，专注于OTA分销。HotelStack.io提供完整的36模块酒店管理平台，内置渠道管理、PMS、餐饮、收益工具等——价格更低。',
  overviewComparison: [
    { label: '平台类型', hotelstack: '一体式HMS（36模块）', competitor: '渠道管理器 + 附加产品' },
    { label: '定价', hotelstack: '起价$49/月', competitor: '起价$99+/月' },
    { label: '内置PMS', hotelstack: '完整PMS包含', competitor: 'Little Hotelier（独立产品）' },
    { label: '餐饮/POS', hotelstack: '内置', competitor: '不可用' },
    { label: '收益管理', hotelstack: '高级（内置）', competitor: '基础收益规则' },
    { label: '预订引擎', hotelstack: 'BookMyRoom.io（免费）', competitor: 'TheBookingButton（附加模块）' },
  ],
  featureTable: [
    {
      category: '核心PMS',
      features: [
        { name: '可视化房态板', hotelstack: true, competitor: false },
        { name: '预订管理', hotelstack: true, competitor: '通过Little Hotelier' },
        { name: '夜审向导', hotelstack: true, competitor: false },
        { name: '宾客账单管理', hotelstack: true, competitor: false },
        { name: '团队预订', hotelstack: true, competitor: false },
        { name: '在线入住门户', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '分销与渠道管理',
      features: [
        { name: '渠道管理（100+ OTA）', hotelstack: true, competitor: true },
        { name: 'GDS连接', hotelstack: true, competitor: true },
        { name: '元搜索集成', hotelstack: true, competitor: true },
        { name: '价格一致性监控', hotelstack: true, competitor: true },
        { name: '直接预订引擎', hotelstack: true, competitor: '附加模块' },
      ],
    },
    {
      category: '收益管理',
      features: [
        { name: '动态定价规则', hotelstack: true, competitor: '基础' },
        { name: '假设场景收益模拟器', hotelstack: true, competitor: false },
        { name: '竞争对手价格监控', hotelstack: true, competitor: false },
        { name: '需求预测', hotelstack: true, competitor: false },
        { name: 'RevPAR分析', hotelstack: true, competitor: '基础' },
      ],
    },
    {
      category: '宾客与运营',
      features: [
        { name: '360度宾客档案', hotelstack: true, competitor: false },
        { name: '客房清洁管理', hotelstack: true, competitor: false },
        { name: 'POS终端', hotelstack: true, competitor: false },
        { name: '客房送餐模块', hotelstack: true, competitor: false },
        { name: '员工排班', hotelstack: true, competitor: false },
        { name: '维修工单', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '多物业与合规',
      features: [
        { name: '连锁酒店仪表盘', hotelstack: true, competitor: '有限' },
        { name: '跨物业分析', hotelstack: true, competitor: false },
        { name: '多币种账单', hotelstack: true, competitor: '有限' },
        { name: '区域税务合规', hotelstack: true, competitor: false },
        { name: '忠诚度计划管理', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '弹性与离线',
      features: [
        { name: '支持离线的PWA', hotelstack: true, competitor: false },
        { name: '离线操作队列', hotelstack: true, competitor: false },
        { name: '重新连接时后台同步', hotelstack: true, competitor: false },
        { name: '冲突感知对账', hotelstack: true, competitor: false },
        { name: '可安装的前台系统', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '企业与团队销售',
      features: [
        { name: '企业协议价管理', hotelstack: true, competitor: false },
        { name: '团队预订与房间名单', hotelstack: true, competitor: false },
        { name: '应收账龄与业绩报表', hotelstack: true, competitor: false },
        { name: '餐厅预订', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '员工与人力资源',
      features: [
        { name: '员工名录与排班', hotelstack: true, competitor: false },
        { name: '薪资处理', hotelstack: true, competitor: false },
        { name: '休假与考勤', hotelstack: true, competitor: false },
        { name: '绩效分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$99+',
    hotelstackNote: '包含全部36个模块——PMS、渠道管理、预订引擎、餐饮、收益管理。支持EUR、GBP、AED、INR、THB区域定价。免费入驻和迁移。',
    competitorNote: '渠道管理器起价$99+/月。PMS（Little Hotelier）和预订引擎（TheBookingButton）为独立产品，需单独收费。无餐饮或运营模块。',
  },
  advantages: [
    '完整的36模块一体式平台，对比SiteMinder仅渠道管理的方式',
    '内置完整PMS——无需另购Little Hotelier进行物业管理',
    '餐饮、POS、客房送餐和厨房管理无额外费用',
    '高级收益管理，含动态定价、需求预测和假设场景模拟器',
    '宾客CRM，含360度档案、忠诚度计划和自动化沟通',
    '运营工具：客房清洁、维修、员工排班全部集成',
    '更低起步价格（$49对$99+），功能显著更多',
    '免费入驻和数据迁移，全天候专属支持',
  ],
  verdict: {
    title: '我们的评价',
    summary: 'SiteMinder作为独立渠道管理器表现出色，拥有近二十年积累的强大OTA连接能力。然而，它不是完整的酒店管理平台。HotelStack.io包含SiteMinder在分销方面提供的一切，加上完整PMS、餐饮/POS、收益管理、宾客CRM和25+额外模块——全部在一个订阅中，价格更低。',
    bestFor: [
      '希望用单一平台替代SiteMinder + PMS + POS组合的酒店',
      '需要超越渠道管理的完整PMS、餐饮和运营工具的物业',
      '需要高级收益管理和需求预测的酒店',
      '觉得SiteMinder仅分销功能价格过高的小型物业',
      '需要所有运营集中管理的多物业连锁酒店',
    ],
  },
  faqItems: [
    { question: '能否从SiteMinder迁移到HotelStack.io？', answer: '可以。我们的迁移团队转移您的OTA连接、房价方案和预订数据。HotelStack.io连接与SiteMinder相同的100多个OTA。迁移免费，通常在48小时内完成，零停机时间。' },
    { question: 'HotelStack.io的渠道管理功能能否匹配SiteMinder？', answer: '可以。HotelStack.io包含完整的渠道管理器，连接100多个OTA、通过Amadeus和Sabre的GDS以及元搜索平台。价格一致性监控和实时库存同步是每个套餐的标准功能。' },
    { question: '为什么选择HotelStack.io而不是SiteMinder + Little Hotelier？', answer: '分别购买SiteMinder（渠道管理）加Little Hotelier（PMS）加TheBookingButton（预订引擎）的费用远高于HotelStack.io，且仍缺少餐饮、收益管理、员工排班和HotelStack.io包含的20多个其他模块。' },
    { question: 'HotelStack.io适合目前使用SiteMinder的小型物业吗？', answer: '当然适合。我们$49/月的入门套餐包含全部36个模块，无功能限制。小型物业获得完整管理平台，而不仅仅是渠道管理器，总成本低于单独使用SiteMinder。' },
  ],
};

const ROOMRACCOON_ZH: ComparisonConfig = {
  slug: 'hotelstack-vs-roomraccoon',
  competitorName: 'RoomRaccoon',
  heroTitle: 'HotelStack.io 对比 RoomRaccoon',
  heroSubtitle: 'RoomRaccoon是一家荷兰AI驱动的HMS，面向精品和小型酒店。HotelStack.io从精品到企业级可扩展，拥有36个模块、高级收益管理、完整餐饮/POS和多物业支持——价格具有竞争力。',
  overviewComparison: [
    { label: '模块总数', hotelstack: '36个集成模块', competitor: '10+模块' },
    { label: '定价', hotelstack: '起价$49/月', competitor: '起价$79+/月' },
    { label: '目标客群', hotelstack: '中小到企业级', competitor: '精品/小型酒店' },
    { label: '餐饮/POS', hotelstack: '内置', competitor: '不可用' },
    { label: '多物业', hotelstack: '完整连锁管理', competitor: '有限' },
    { label: '全球覆盖', hotelstack: '40多个国家', competitor: '主要覆盖欧洲' },
  ],
  featureTable: [
    {
      category: '核心PMS',
      features: [
        { name: '可视化房态板', hotelstack: true, competitor: true },
        { name: '预订管理', hotelstack: true, competitor: true },
        { name: '夜审向导', hotelstack: true, competitor: true },
        { name: '宾客账单管理', hotelstack: true, competitor: true },
        { name: '团队预订', hotelstack: true, competitor: '有限' },
        { name: '在线入住门户', hotelstack: true, competitor: true },
      ],
    },
    {
      category: '收益与分销',
      features: [
        { name: '渠道管理（100+ OTA）', hotelstack: true, competitor: 'OTA数量较少' },
        { name: 'AI驱动收益管理', hotelstack: true, competitor: true },
        { name: '动态定价规则', hotelstack: true, competitor: '基础' },
        { name: '假设场景收益模拟器', hotelstack: true, competitor: false },
        { name: '竞争对手价格监控', hotelstack: true, competitor: false },
        { name: '需求预测', hotelstack: true, competitor: '基础' },
      ],
    },
    {
      category: '宾客管理',
      features: [
        { name: '360度宾客档案', hotelstack: true, competitor: '基础' },
        { name: '忠诚度计划管理', hotelstack: true, competitor: false },
        { name: '宾客沟通自动化', hotelstack: true, competitor: true },
        { name: '宾客消费分析', hotelstack: true, competitor: false },
        { name: '证件上传与验证', hotelstack: true, competitor: true },
      ],
    },
    {
      category: '餐饮与运营',
      features: [
        { name: 'POS终端', hotelstack: true, competitor: false },
        { name: '客房送餐模块', hotelstack: true, competitor: false },
        { name: '厨房显示系统', hotelstack: true, competitor: false },
        { name: '客房清洁管理', hotelstack: true, competitor: true },
        { name: '维修工单', hotelstack: true, competitor: false },
        { name: '员工排班', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '企业级与多物业',
      features: [
        { name: '连锁酒店仪表盘', hotelstack: true, competitor: '有限' },
        { name: '跨物业分析', hotelstack: true, competitor: false },
        { name: '集中化价格管理', hotelstack: true, competitor: false },
        { name: '品牌标准执行', hotelstack: true, competitor: false },
        { name: '平台超级管理员', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '弹性与离线',
      features: [
        { name: '支持离线的PWA', hotelstack: true, competitor: false },
        { name: '离线操作队列', hotelstack: true, competitor: false },
        { name: '重新连接时后台同步', hotelstack: true, competitor: false },
        { name: '冲突感知对账', hotelstack: true, competitor: false },
        { name: '可安装的前台系统', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '企业与团队销售',
      features: [
        { name: '企业协议价管理', hotelstack: true, competitor: false },
        { name: '团队预订与房间名单', hotelstack: true, competitor: '有限' },
        { name: '应收账龄与业绩报表', hotelstack: true, competitor: false },
        { name: '餐厅预订', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '员工与人力资源',
      features: [
        { name: '员工名录与排班', hotelstack: true, competitor: false },
        { name: '薪资处理', hotelstack: true, competitor: false },
        { name: '休假与考勤', hotelstack: true, competitor: false },
        { name: '绩效分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$79+',
    hotelstackNote: '包含全部36个模块。从10间客房精品到500+间客房企业级可扩展。支持EUR、GBP、AED、INR、THB区域定价。免费入驻和迁移。',
    competitorNote: '分层定价，起价EUR 79+/月。高级功能限于更高层级。企业级和多物业功能有限。',
  },
  advantages: [
    '模块数量超过三倍（36对10+），无功能被锁定在高级层级',
    '从精品到企业级可扩展——RoomRaccoon限于小型/中型物业',
    '完整的餐饮模块，含POS、客房送餐和厨房管理',
    '完整的多物业连锁管理，含集中分析和房价分销',
    '超越基础AI收益管理——包含需求预测和模拟器',
    '忠诚度计划管理，促进宾客留存和复购增长',
    '覆盖40多个国家，对比RoomRaccoon聚焦欧洲',
    '员工管理，含排班、薪资和绩效追踪',
  ],
  verdict: {
    title: '我们的评价',
    summary: 'RoomRaccoon对于寻求AI驱动PMS和现代界面的欧洲小型精品酒店是可靠选择。然而，它缺乏成长中物业所需的深度、可扩展性和运营广度。HotelStack.io提供RoomRaccoon的一切加上餐饮/POS、企业级多物业管理、高级收益工具和全球合规——使其成为更强的长期投资。',
    bestFor: [
      '希望获得企业级功能但无需企业级定价的精品酒店',
      '需要HMS中包含餐饮、POS和厨房管理的物业',
      '计划从单一物业扩展到多物业连锁的酒店',
      '欧洲以外需要全球合规和分销的物业',
      '需要超越基础收益优化的高级收益管理的酒店',
    ],
  },
  faqItems: [
    { question: '能否从RoomRaccoon迁移到HotelStack.io？', answer: '可以。我们的迁移团队负责从RoomRaccoon完整迁移数据，包括宾客档案、预订历史、房价方案和房间配置。迁移免费，通常在48小时内完成，零停机时间。' },
    { question: 'HotelStack.io是否有像RoomRaccoon一样的AI功能？', answer: '有。HotelStack.io包含智能收益管理、需求预测、动态定价规则和收益模拟器。我们的AI驱动工具超越基础收益优化，包括竞争对手监控和假设场景规划。' },
    { question: 'HotelStack.io像RoomRaccoon一样适合精品酒店吗？', answer: '当然适合。我们的入门套餐专为所有规模的物业设计，包括精品酒店。从第一天起即享全部36个模块，无功能限制，现代暗色奢华UI提供精品物业欣赏的优雅体验。' },
    { question: 'HotelStack.io与RoomRaccoon在多物业管理方面如何比较？', answer: 'HotelStack.io包含完整的连锁管理仪表盘，含跨物业分析、集中房价分销、品牌标准和合并报表。RoomRaccoon的多物业支持有限，使HotelStack.io成为成长中酒店集团的更佳选择。' },
  ],
};

export const COMPARISON_ZH_P3: Record<string, ComparisonConfig> = {
  'hotelstack-vs-siteminder': SITEMINDER_ZH,
  'hotelstack-vs-roomraccoon': ROOMRACCOON_ZH,
  ...COMPARISON_ZH_P3B,
};
